import { Stack, Chip, ToggleButton, ToggleButtonGroup } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { endpoint } from "../../../config"
import { updateQuery, updateQueryContentRating, updateVideos } from "../../../reduxStore"

export default function ContentRatings(props){
    const {contentRatings} = useSelector(state => state.filters)
    const query = useSelector(state => state.query)

    const dispatch = useDispatch()

    const [selectedContentRating, setSelectedContentRating] = useState()

    const handleContentRatings = (newSelectedContentRating) => {
        console.log(newSelectedContentRating)
        newSelectedContentRating === selectedContentRating 
            ? setSelectedContentRating('')
            : setSelectedContentRating(newSelectedContentRating)
    }

    // const handleChange = (e, newSelectedContentRating) => {
    //     console.log(newSelectedContentRating)
    //     setSelectedContentRating(newSelectedContentRating)
    // }

    const filterVideos = async () => {
        let url = `${endpoint}?contentRating=${query.contentRating.replace(/\+$/g, '%2B')}`
        if(query.genres.length) url += `&genres=${query.genres.join(',')}`
        if(query.title) url += `&title=${query.title}`
        // console.log(url)
        const res = await axios.get(url)
        // const res = await axios.get(`${endpoint}?contentRating=${selectedContentRating.replace(/\+$/g, '%2B')}`)
        dispatch(updateVideos(res.data.videos))
    }

    useEffect(() => {
        dispatch(updateQueryContentRating(selectedContentRating))
        // if(selectedContentRating) 
        filterVideos()
    }, [selectedContentRating])

    return (
        <Stack 
            className="contentRatings" 
            direction='row' 
            justifyContent='space-around' 
            alignItems='center' 
            sx={{
                width: "100%",
                maxWidth: 350,
                padding: '0.5rem'
            }}
        >
            <Stack direction='row' justifyContent='space-around' flexWrap='wrap' sx={{width: '100%'}}>
                {
                    contentRatings.map(contentRating => (
                        <Chip 
                            key={contentRating}
                            label={contentRating} 
                            onClick={() => handleContentRatings(contentRating)}
                            color={selectedContentRating === contentRating ? 'secondary' : 'primary'}
                        />
                    ))
                }
            </Stack>
        </Stack>
    )
}